module.exports = __webpack_public_path__ + "img/white-bg.4aa64e19.jpg";